import React, { useState }from 'react'
import { Link } from 'react-router-dom';
import home from './images/home (3).png';
import idea from './images/idea.png';
import user from './images/user.png';
import brightness from './images/brightness.png';
import './Navbar.css'

function Navbar() {

  return (
    <div className='navbar-container'>
      <div className='navbar'>
          <Link to='/'>
              <img src={home} alt='home' className='home'></img>
          </Link>
          <Link to='/problems'>
              <img src={idea} alt='problem' className='problems'></img>
          </Link>
          <Link to='/profile'>
              <img src={user} alt='profile' className='profile'></img>
          </Link>          
      </div>
    </div>
  )
}

export default Navbar